import { createColumnHelper, AccessorFn, DisplayColumnDef } from "@tanstack/react-table";
import { Typography } from "components/miloDesignSystem/atoms/typography";
import { TypographyProps } from "components/miloDesignSystem/atoms/typography/types";
import { dateFns } from "utilities/utilities";
import { Assign } from "utility-types";

export const dateColumn = <T,>(
  accessorFn: AccessorFn<T, string | null>,
  columnDef: Assign<
    Pick<DisplayColumnDef<T>, "size">,
    { typographyProps?: TypographyProps; header: string; format?: string }
  >,
) => {
  const baseColumnHelper = createColumnHelper<T>();
  return baseColumnHelper.accessor(accessorFn, {
    header: columnDef.header,
    size: columnDef.size,
    cell: info => {
      const value = info.getValue();
      const formattedDate = value ? dateFns.format(new Date(value), "dd.MM.yyyy") : "";

      return (
        <Typography
          fontSize={columnDef.typographyProps?.fontSize || "12"}
          fontWeight={columnDef.typographyProps?.fontWeight || "700"}
          {...columnDef.typographyProps}
        >
          {formattedDate}
        </Typography>
      );
    },
  });
};
